/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset tag for productivity.
 */
export var AssetTag;
(function (AssetTag) {
    AssetTag["LOADER"] = "Loader";
    AssetTag["HAULER"] = "Hauler";
})(AssetTag || (AssetTag = {}));
